"use client"
import { useEffect } from "react";

export default function LandingUtils(){
    useEffect(() => {
        // URL parameters and local storage logic
        // var urlParams = new URLSearchParams(window.location.search);
        // if (urlParams.has('tag')) {
        //   localStorage.setItem('affiliation_tag', urlParams.get('tag')!);
        // }
    })
    return (
        <></>
    )
}